import * as angular from 'angular';
import TasksService from '../TasksService';
import AppConstants from '../../gorillaboy/AppConstants';
import SignalProvider from '../../gorillaboy/SignalProvider';

angular.module('GorillaBoy')
.controller('accessRequestModalCtrl', [
    '$rootScope',
    '$scope',
    '$log',
    '$location',
    '$translate',
    'TargetResourceId',
    'TasksService',
    'SignalProvider',
    'MessageManager',
    function accessRequestModalCtrl($rootScope: ng.IRootScopeService, $scope: ng.IScope, $log: ng.ILogService, $location: ng.ILocationService, $translate ,TargetResource, TasksService: TasksService, SignalProvider, MessageManager) {
        // Initialization
        $scope.formData = {
            link: '',
            description: ''
        };
        $scope.linkErrorMessage = '';
        $scope.targetResourceId = TargetResource;

        $scope.createAccessRequestTask = function() {
            var docId = null,
                description = null;
            if (!!$scope.targetResourceId) {
                docId = $scope.targetResourceId;
                description = $scope.formData.description;
            } else {
                docId = getResourceIdFromLink($scope.formData.link);
                description = $scope.formData.link;
            }
            
            TasksService.createTask(null, description, docId, AppConstants.TASKDEF_IDS.REQUEST_ACCESS).then(()=> {
                MessageManager.addSuccessMessage($translate.instant('TASKS.CREATE_TASK_MODAL.CREATE_ACCESS_REQUEST.SUCCESS_MESSAGE'));
                $rootScope.$broadcast(SignalProvider.Task.AccessRequestCreated);
            }, ()=> {
                MessageManager.addErrorMessage($translate.instant('TASKS.CREATE_TASK_MODAL.CREATE_ACCESS_REQUEST.ERROR_MESSAGE'));
            }).finally(()=> {
                $scope.$close();
            });
        };

        $scope.$watch('formData.link', function(newVal: string, oldVal: string) {
            newVal = newVal? newVal.trim(): '';
            oldVal = oldVal? oldVal.trim(): '';
            if (newVal === oldVal) {
                return ;
            }

            var newValParser = document.createElement('a');
            newValParser.href = newVal;

            if (newValParser.hostname !== $location.host()) {
                $scope.linkErrorMessage = 'The link you have entered does not belong to this WorkDocs website. Please check';
                return;
            } else if (newValParser.hash.lastIndexOf('document/') === -1 && newValParser.hash.lastIndexOf('folder/') === -1) {
                $scope.linkErrorMessage = 'The link you have entered is not valid. Please check';
                return;
            }

            $scope.linkErrorMessage = '';
        });

        $scope.showLinkErrorAlert = function() {
            return !!$scope.formData.link && $scope.linkErrorMessage;
        }

        function getResourceIdFromLink(link) {
            var parser = document.createElement('a');
            parser.href = link;
            if (parser.hash.lastIndexOf('document/') !== -1) {
                return parser.hash.substr(parser.hash.lastIndexOf('document/') + 9);
            } else if (parser.hash.lastIndexOf('folder/') !== -1) {
                return parser.hash.substr(parser.hash.lastIndexOf('folder/') + 7);
            }
            $log.error('Cannot get resource ID from given link');
            return null;
        }
    }
]);